<script setup lang="ts">
import { RouterLink } from 'vue-router'
import Icon from '@/components/icons/Icon.vue'
</script>

<template>
  <footer class="footer">
    <div class="container footer__inner">
      <div class="footer__brand">
        <RouterLink to="/" class="footer__logo">
          <span class="footer__logo-icon" aria-hidden="true">
            <Icon name="calculator" :size="18" />
          </span>
          ClearRand
        </RouterLink>
        <p class="footer__tagline">
          Free, clear South African financial and practical calculators.
        </p>
      </div>
      <nav aria-label="Footer" class="footer__nav">
        <div class="footer__group">
          <p class="footer__group-title">Product</p>
          <ul>
            <li><RouterLink to="/calculators">Calculators</RouterLink></li>
            <li><RouterLink to="/about">About</RouterLink></li>
            <li><RouterLink to="/methodology">Methodology</RouterLink></li>
          </ul>
        </div>
        <div class="footer__group">
          <p class="footer__group-title">Legal</p>
          <ul>
            <li><RouterLink to="/privacy">Privacy</RouterLink></li>
            <li><RouterLink to="/terms">Terms</RouterLink></li>
            <li><RouterLink to="/disclaimer">Disclaimer</RouterLink></li>
          </ul>
        </div>
      </nav>
    </div>
    <div class="container footer__legal-row">
      <p class="footer__legal">
        &copy; {{ new Date().getFullYear() }} ClearRand. No financial, tax, legal or lending advice.
      </p>
    </div>
  </footer>
</template>

<style scoped>
.footer {
  margin-top: auto;
  padding: var(--space-10) 0 var(--space-6);
  background:
    linear-gradient(to bottom, var(--color-surface), rgb(10 92 86 / 0.03)), var(--color-surface);
  border-top: 1px solid var(--color-border);
}

.footer__inner {
  display: grid;
  gap: var(--space-8);
}

@media (min-width: 640px) {
  .footer__inner {
    grid-template-columns: 1.25fr 1fr;
    align-items: start;
  }
}

.footer__logo {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  font-weight: var(--font-bold);
  font-size: var(--text-xl);
  color: var(--color-text);
  text-decoration: none;
}

.footer__logo:hover {
  text-decoration: none;
}

.footer__logo-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: var(--radius-md);
  background-color: var(--color-primary);
  color: white;
}

.footer__tagline {
  color: var(--color-text-muted);
  margin-top: var(--space-2);
  max-width: 36ch;
}

.footer__nav {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--space-6);
}

.footer__group-title {
  font-weight: var(--font-semibold);
  font-size: var(--text-sm);
  color: var(--color-text);
  margin-bottom: var(--space-2);
}

.footer__group ul {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  list-style: none;
  margin: 0;
  padding: 0;
}

.footer__group a {
  color: var(--color-text-muted);
  font-size: var(--text-sm);
}

.footer__group a:hover {
  color: var(--color-primary);
}

.footer__legal-row {
  margin-top: var(--space-8);
  padding-top: var(--space-5);
  border-top: 1px solid var(--color-border);
}

.footer__legal {
  color: var(--color-text-muted);
  font-size: var(--text-sm);
}
</style>
